import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=01dc8cfb&scoped=true"
import script from "./PostCard.vue?vue&type=script&lang=js"
export * from "./PostCard.vue?vue&type=script&lang=js"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=01dc8cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc8cfb",
  null
  
)

export default component.exports